import { render, staticRenderFns } from "./createUser.vue?vue&type=template&id=e6e50554"
import script from "./createUser.vue?vue&type=script&lang=js"
export * from "./createUser.vue?vue&type=script&lang=js"
import style0 from "./createUser.vue?vue&type=style&index=0&id=e6e50554&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports